<template>
  <div class="search-site-budget">
    <BudgetSlider v-model="budget"/>
    <div class="search-site-submit">
      <button @click="onSubmit" type="button"><span>{{ $t("חפש") }}</span></button>
    </div>

    <form ref="form" :action="siteData.vacation_plan" method="post">
      <input type="hidden" name="budget" v-model="budget" />
      <input type="hidden" name="sites" value="2114,2035,1715,1993,1828,9334,1958,1548,1381,101,822,2254,2378,2179" />
      <input type="hidden" name="all_selected" value="true" />
      <input type="hidden" name="date" value="null" />
      <input type="hidden" name="types" value="{&quot;week&quot;:true,&quot;weekend&quot;:true,&quot;weekday&quot;:true}" />
      <input type="hidden" name="custom" value="1" />
    </form>
  </div>
</template>

<script>
import BudgetSlider from './BudgetSlider.vue';

export default {
  components: {BudgetSlider},

  data() {
    return {
      siteData: window.siteData,
      budget: [400, 2000]
    }
  },

  methods: {
    onSubmit() {
      this.$refs.form.submit();
    }
  }
};
</script>
